/* jshint esversion: 6, -W097 */
/* globals require */
(function(angular) {
    'use strict';
    var app = angular.module('enervee');

    app.directive('forgotPasswordModal', [
        function() {
            return {
                restrict: 'E',
                template: require('@app/shared/modals/forgotPassword/forgotPassword.html'),
            };
        }
    ]);
})(angular);